// src/helpers.ts

import axios from "axios";
import { brandConfig } from "./brandConfig";
import { getIpfsGatewayUrl } from "./utils/ipfsConfig";

export const getApiUrl = () => {
  // Check for explicit environment variable first
  const envEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT;

  if (envEndpoint) {
    console.log("Using GraphQL endpoint from env:", envEndpoint);


    return envEndpoint;
    
  }

  // Default to production unless explicitly set to development
  const isDevelopment = process.env.REACT_APP_ENV === "development";
  const endpoint = isDevelopment
    ? "http://localhost:4000/graphql"
    : "https://api.surgready.com.au/graphql";

  console.log("Using GraphQL endpoint:", endpoint);
  return endpoint;
};


export const getBitcoinPrice = async (): Promise<number> => {
  try {
    const response = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=aud");
    return response.data.bitcoin.aud;
  } catch (error) {
    console.error("Error fetching BTC price:", error);
    return 0; // Return 0 or some default value in case of an error
  }
};

export const calculateBTCAmount = (audAmount: number, btcPrice: number): number => {
  return audAmount / btcPrice;
};

/**
 * Ensures an IPFS gateway URL has the https:// protocol.
 */
export const normalizeIpfsUrl = (url: string): string => {
  if (!url) return url;

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  if (url.includes('files.tommillerservices.com')) {
    return `https://${url}`;
  }

  return url;
};

/**
 * Normalizes a media URL for display.
 */
export const normalizeMediaUrl = (url?: string): string => {
  if (!url) return '';
  return normalizeIpfsUrl(url);
};

/**
 * Builds IPFS URL from hash using configured gateway
 * This is the recommended function for all IPFS URL building
 * Falls back to default gateway if tenant config not available
 * @param hash - The IPFS hash or complete URL
 * @param tenantGatewayUrl - Optional tenant-specific gateway URL from backend
 * @returns Complete IPFS URL with proper protocol
 */
export const buildIPFSUrl = (hash: string, tenantGatewayUrl?: string): string => {
  if (!hash) return '';

  // If already a complete URL, return as-is
  if (hash.startsWith('http://') || hash.startsWith('https://')) {
    return hash;
  }

  // Use tenant-specific gateway if provided, otherwise use singleton from backend tenant record
  let gatewayBase = tenantGatewayUrl || getIpfsGatewayUrl();
  if (!gatewayBase) return hash;

  // Ensure https:// protocol
  if (!gatewayBase.startsWith('http://') && !gatewayBase.startsWith('https://')) {
    gatewayBase = `https://${gatewayBase}`;
  }

  // Remove any leading slashes from hash
  const cleanHash = hash.startsWith('/') ? hash.slice(1) : hash;

  // Ensure /ipfs/ path between gateway domain and hash
  // Handles: "https://files.x.com", "https://files.x.com/ipfs", "https://files.x.com/ipfs/"
  if (gatewayBase.endsWith('/ipfs') || gatewayBase.endsWith('/ipfs/')) {
    return `${gatewayBase.replace(/\/$/, '')}/${cleanHash}`;
  }
  return `${gatewayBase.replace(/\/$/, '')}/ipfs/${cleanHash}`;
};